if (!customElements.get("fp-countdown")) {
  customElements.define(
    "fp-countdown",
    class FPCountdown extends HTMLElement {
      constructor() {
        super();

        this._calculateTimeRemaining = this._calculateTimeRemaining.bind(this);
        this._updateCountdownDisplay = this._updateCountdownDisplay.bind(this);
      }

      connectedCallback() {
        const containerEl = this.querySelector("[data-countdown-date]");
        const targetDateString = containerEl.getAttribute("data-countdown-date");
        const [tMonth, tDay, tYear] = targetDateString.split("-").map(Number);
        const [tHours, tMinutes] = (
          this.querySelector("[data-countdown-start-time]")?.getAttribute("data-countdown-start-time") || "12:00"
        )
          .split(":")
          .map(Number);
        const days = this.querySelector("[data-day]");
        const hours = this.querySelector("[data-hours]");
        const minutes = this.querySelector("[data-minutes]");
        const daysLabel = this.querySelector("[data-days-label]");
        const hoursLabel = this.querySelector("[data-hours-label]");
        const minutesLabel = this.querySelector("[data-minutes-label]");
        const labelElements = { daysLabel, hoursLabel, minutesLabel };

        if (!containerEl || !targetDateString || !days || !hours || !minutes) {
          console.warn("[fp-countdown] Missing required elements");
          return;
        }

        this.targetDate = new Date(Date.UTC(tYear, tMonth - 1, tDay, tHours, tMinutes));

        if (isNaN(this.targetDate.getTime())) {
          console.error("[fp-countdown] Invalid date");
          return;
        }

        this.elements = { days, hours, minutes, ...labelElements };
        this.labels = Object.fromEntries(
          Object.entries(labelElements).map(([key, labelEl]) => [
            key,
            JSON.parse(labelEl.getAttribute(`data-${key.replace("Label", "")}-label`)),
          ]),
        );
        this.timerInterval = setInterval(this._updateCountdownDisplay, 1000);
      }

      disconnectedCallback() {
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
        }
      }

      _calculateTimeRemaining() {
        const now = new Date().getTime();
        const timeLeft = this.targetDate - now;
        const { daysLabel, hoursLabel, minutesLabel } = this.labels;

        if (timeLeft <= 0) {
          clearInterval(this.timerInterval);
          return {
            days: 0,
            hours: 0,
            minutes: 0,
            daysLabel: daysLabel.plural,
            hoursLabel: hoursLabel.plural,
            minutesLabel: minutesLabel.plural,
          };
        }

        // NOTE: Convert milliseconds to days, hours, minutes
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

        return {
          days,
          hours,
          minutes,
          daysLabel: (days > 1 ? daysLabel.plural : daysLabel.singular) + " : ",
          hoursLabel: (hours > 1 ? hoursLabel.plural : hoursLabel.singular) + " : ",
          minutesLabel: minutes > 1 ? minutesLabel.plural : minutesLabel.singular,
        };
      }

      _updateCountdownDisplay() {
        const timeRemainingData = this._calculateTimeRemaining();

        Object.entries(this.elements).forEach(([key, el]) => {
          el.textContent = timeRemainingData[key];
        });
      }
    },
  );
}
